import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';

import { MainService } from 'app/resources/services/index';
import { DefineBootboxId } from 'app/resources/classes';

@Component({
  selector: 'app-vitrine',
  templateUrl: './vitrine.component.html',
  styleUrls: ['./vitrine.component.css']
})
export class VitrineComponent implements OnInit {

  public bootboxAlertComId: DefineBootboxId = new DefineBootboxId();
  public valePresente: any;
  public quantidade: number;

  constructor(public mainService: MainService, public router: Router) { }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.valePresente = this.mainService.valePresenteService.valePresente;
    this.quantidade = this.mainService.valePresenteService.quantidade;
  }

  public selecionar(valePresente) {
    this.valePresente = valePresente;
    this.quantidade = 1;
  }

  public add() {
    if (!this.mainService.valePresenteCestaService.hasValePresente(this.valePresente) &&
      this.mainService.valePresenteCestaService
        .add(this.valePresente, this.quantidade, this.mainService.cartaoService.cartao.indiceMoeda)) {
      this.valePresente = {};
      this.quantidade = 1;
      this.router.navigate(['/valepresente/cesta']);
    } else if (this.mainService.valePresenteCestaService.hasValePresente(this.valePresente)) {
      this.bootboxAlertComId.alerta('Este vale presente já foi adicionado a sua cesta.'
        + 'Para alterar a quantidade e/ou valor, por favor remova e adicione-o novamente em sua cesta.');
    } else {
      this.bootboxAlertComId.alerta('Dados inválido. Por favor selecione um vale presente e a quantidade desejada.');
    }
  }

  public isSelecionado(valePresente) {
    return this.valePresente && valePresente && this.valePresente.id === valePresente.id;
  };
}



// WEBPACK FOOTER //
// ./src/app/vale-presente/vitrine/vitrine.component.ts